import request from '@/utils/request'

// 获取菜单列表
export function menulist(query) {
  return request({
    url: '/api/index/menulist',
    method: 'get',
    params: query
  })
}
// 获取手机菜单列表
export function mMenulist(query) {
  return request({
    url: '/api/index/m_menulist',
    method: 'get',
    params: query
  })
}
// 获取基本信息
export function getsite(query) {
    return request({
      url: '/api/index/getsite',
      method: 'get',
      params: query
    })
  }
  
// 获取菜单详情
export function getmenudetail(query) {
  return request({
    url: '/api/index/getmenudetail',
    method: 'POST',
    params: query
  })
}
// 获取特色医疗列表
export function medicallist(query) {
  return request({
    url: '/api/index/medicallist',
    method: 'get',
    params: query
  })
}

// 特色医疗详情
export function medicalDetail(query) {
  return request({
    url: '/api/index/medicalDetail',
    method: 'post',
    params: query
  })
}

// 根据特色医疗分类获取病历简介
export function synopsislBymedicalId(query) {
  return request({
    url: '/api/index/synopsislBymedicalId',
    method: 'post',
    params: query
  })
}
// 病历简介详情
export function synopsisDetail(query) {
  return request({
    url: '/api/index/synopsisDetail',
    method: 'post',
    params: query
  })
}
// 分页获取新闻
export function newslist(query) {
  return request({
    url: '/api/index/newslist',
    method: 'GET',
    params: query
  })
}
// 新闻详情
export function newsdetail(query) {
  return request({
    url: '/api/index/newsdetail',
    method: 'post',
    params: query
  })
}

// 就医指南+视频推荐
export function guideAndVideo(query) {
  return request({
    url: '/api/index/guideAndVideo',
    method: 'post',
    params: query
  })
}

// 视频列表
export function videolist(query) {
  return request({
    url: '/api/index/videolist',
    method: 'GET',
    params: query
  })
}

// 视频列表
export function videodetail(query) {
  return request({
    url: '/api/index/videodetail',
    method: 'POST',
    params: query
  })
}

// 视频列表
export function guidedetail(query) {
  return request({
    url: '/api/index/guidedetail',
    method: 'POST',
    params: query
  })
}

// 视频列表
export function addsubscribe(query) {
  return request({
    url: '/api/ajax/addsubscribe',
    method: 'POST',
    params: query
  })
}





// 获取调查问卷列表
export function getquestionlist(query) {
  return request({
    url: '/api/index/getquestionlist',
    method: 'post',
    params: query
  })
}

// 获取招聘信息列表
export function getjoblist(query) {
  return request({
    url: '/api/index/getjoblist',
    method: 'post',
    params: query
  })
}


// 在线留言
export function addconsultation(query) {
  return request({
    url: '/api/ajax/addconsultation',
    method: 'post',
    params: query
  })
}



// 调查问卷提交
export function addquestion(query) {
  return request({
    url: 'api/ajax/addquestion',
    method: 'post',
    data: query
  })
}
// 调查问卷提交
export function synopsistop6(query) {
  return request({
    url: 'api/index/synopsistop6',
    method: 'get',
    params: query
  })
}

// 分享
export function share(query) {
  return request({
    url: 'api/Wechat/share',
    method: 'post',
    params: query
  })
}


// WEBPACK FOOTER //
// ./src/api/common.js